// Generated by protoc-gen-vendasta-ts — DO NOT EDIT
/* eslint-disable */
export function filterToJson(m) {
    const o = {};
    if (m.fieldId !== undefined)
        o['fieldId'] = m.fieldId;
    if (m.operator !== undefined)
        o['operator'] = m.operator;
    if (m.values !== undefined) {
        o['values'] = m.values.map(e => filterValueToJson(e));
    }
    if (m.floatTolerance !== undefined)
        o['floatTolerance'] = m.floatTolerance;
    return o;
}
export function filterFromJson(o) {
    var _a, _b, _c, _d;
    return {
        fieldId: (_a = o['fieldId']) !== null && _a !== void 0 ? _a : '',
        operator: (_b = o['operator']) !== null && _b !== void 0 ? _b : 'FILTER_OPERATOR_INVALID',
        values: ((_c = o['values']) !== null && _c !== void 0 ? _c : []).map(e => filterValueFromJson(e)),
        floatTolerance: (_d = o['floatTolerance']) !== null && _d !== void 0 ? _d : 0,
    };
}
export function filterValueToJson(m) {
    const o = {};
    if (m.value !== undefined) {
        if (m.value.type === 'boolean') {
            o['boolean'] = m.value.boolean;
        }
        if (m.value.type === 'integer') {
            o['integer'] = m.value.integer;
        }
        if (m.value.type === 'float') {
            o['float'] = m.value.float;
        }
        if (m.value.type === 'string') {
            o['string'] = m.value.string;
        }
        if (m.value.type === 'date') {
            o['date'] = m.value.date.toISOString();
        }
        if (m.value.type === 'dateDefault') {
            o['dateDefault'] = m.value.dateDefault;
        }
        if (m.value.type === 'phone') {
            o['phone'] = phoneToJson(m.value.phone);
        }
    }
    else {
        if (m.boolean !== undefined)
            o['boolean'] = m.boolean;
        if (m.integer !== undefined)
            o['integer'] = m.integer;
        if (m.float !== undefined)
            o['float'] = m.float;
        if (m.string !== undefined)
            o['string'] = m.string;
        if (m.date !== undefined)
            o['date'] = m.date.toISOString();
        if (m.dateDefault !== undefined)
            o['dateDefault'] = m.dateDefault;
        if (m.phone !== undefined)
            o['phone'] = phoneToJson(m.phone);
    }
    return o;
}
export function filterValueFromJson(o) {
    return {
        value: (() => {
            if (o['boolean'] !== undefined)
                return { type: 'boolean', boolean: o['boolean'] };
            if (o['integer'] !== undefined)
                return { type: 'integer', integer: o['integer'] };
            if (o['float'] !== undefined)
                return { type: 'float', float: o['float'] };
            if (o['string'] !== undefined)
                return { type: 'string', string: o['string'] };
            if (o['date'] !== undefined)
                return { type: 'date', date: o['date'] ? new Date(o['date']) : undefined };
            if (o['dateDefault'] !== undefined)
                return { type: 'dateDefault', dateDefault: o['dateDefault'] };
            if (o['phone'] !== undefined)
                return { type: 'phone', phone: o['phone'] ? phoneFromJson(o['phone']) : undefined };
            return undefined;
        })(),
        boolean: o['boolean'] !== undefined ? o['boolean'] : undefined,
        integer: o['integer'] !== undefined ? o['integer'] : undefined,
        float: o['float'] !== undefined ? o['float'] : undefined,
        string: o['string'] !== undefined ? o['string'] : undefined,
        date: o['date'] !== undefined ? o['date'] ? new Date(o['date']) : undefined : undefined,
        dateDefault: o['dateDefault'] !== undefined ? o['dateDefault'] : undefined,
        phone: o['phone'] !== undefined ? o['phone'] ? phoneFromJson(o['phone']) : undefined : undefined,
    };
}
export function filterGroupToJson(m) {
    const o = {};
    if (m.operator !== undefined)
        o['operator'] = m.operator;
    if (m.filters !== undefined) {
        o['filters'] = m.filters.map(e => filterToJson(e));
    }
    return o;
}
export function filterGroupFromJson(o) {
    var _a, _b;
    return {
        operator: (_a = o['operator']) !== null && _a !== void 0 ? _a : 'FILTER_GROUP_OPERATOR_INVALID',
        filters: ((_b = o['filters']) !== null && _b !== void 0 ? _b : []).map(e => filterFromJson(e)),
    };
}
export function phoneToJson(m) {
    const o = {};
    if (m.isoCountryCode !== undefined)
        o['isoCountryCode'] = m.isoCountryCode;
    if (m.nationalNumber !== undefined)
        o['nationalNumber'] = m.nationalNumber;
    if (m.extension !== undefined)
        o['extension'] = m.extension;
    return o;
}
export function phoneFromJson(o) {
    var _a, _b, _c;
    return {
        isoCountryCode: (_a = o['isoCountryCode']) !== null && _a !== void 0 ? _a : '',
        nationalNumber: (_b = o['nationalNumber']) !== null && _b !== void 0 ? _b : '',
        extension: (_c = o['extension']) !== null && _c !== void 0 ? _c : '',
    };
}
